module.exports = __webpack_public_path__ + "img/xinke.9005b172.jpg";